import DeleteKeyContainer from './containers/DeleteKeyContainer'

export default DeleteKeyContainer
